module.exports = __webpack_public_path__ + "img/downloaded.6ce06e35.png";